import { Box, Flex, Text } from "@radix-ui/themes";
import Image from "next/image";

export const CoreCompetencies = () => {
  return (
    <Flex
      direction={"column"}
      justify={"start"}
      align={"center"}
      gap={"6"}
      className={"mt-32"}
    >
      <Flex direction={"column"} justify={"start"} align={"center"} gap={"1"}>
        <Text
          size={"4"}
          weight={"medium"}
          style={{
            color: "var(--tomato-9)",
            fontWeight: "600",
          }}
        >
          핵심 역량
        </Text>
        <Text
          size={"6"}
          align={"center"}
          style={{
            fontWeight: "600",
            lineHeight: 1.3
          }}
        >
          문제를 유연하게 풀고
          <br />
          구조는 견고하게 만듭니다.
        </Text>
      </Flex>
      <Flex className={"core-competencies max-w-5xl"} gap={"6"}>
        {competencies.map((item) => (
          <CompetencyCard key={item.title} {...item} />
        ))}
      </Flex>
    </Flex>
  );
};

type Competency = {
  thumbnail: string;
  isVideo?: boolean;
  title: string;
  description: string;
};

const CompetencyCard = ({
  thumbnail,
  isVideo,
  title,
  description,
}: Competency) => {
  return (
    <Flex direction={"column"} justify={"start"} align={"center"} gap={"4"}>
      <Box
        className={
          "w-full max-w-80 h-60 bg-[var(--sand-3)] rounded-lg overflow-hidden"
        }
        style={{
          border: "1px solid var(--sand-2)",
        }}
      >
        {isVideo ? (
          <video
            src={thumbnail}
            autoPlay
            loop
            muted
            playsInline
            className={"w-full h-full object-cover"}
          />
        ) : (
          <Image
            src={thumbnail}
            alt={title}
            width={0}
            height={0}
            sizes={"100vw"}
            quality={75}
            className={"w-full h-full object-cover"}
          />
        )}
      </Box>
      <Flex
        direction={"column"}
        justify={"start"}
        gap={"2"}
        className={"max-w-80"}
      >
        <Text
          size={"4"}
          style={{
            fontWeight: "600",
          }}
        >
          {title}
        </Text>
        <Text size={"3"} color={"gray"}>
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};

const competencies: Competency[] = [
  {
    thumbnail: "/images/competency_1.png",
    title: "모던 프론트엔드 개발",
    description:
      "React를 중심으로 JavaScript(ES6), TypeScript에 능숙합니다. Next.js와 더불어 Zustand 등 다양한 라이브러리 활용 경험이 있습니다.",
  },
  {
    thumbnail: "/images/competency_2.webm",
    isVideo: true,
    title: "3D 인터랙티브 웹 서비스 개발",
    description:
      "Three.js를 활용해 복잡한 사용자 인터랙션을 포함한 3D 웹 서비스를 개발했습니다. 시각적 표현뿐 아니라 성능과 사용성을 고려한 설계 경험이 있습니다.",
  },
  {
    thumbnail: "/images/competency_3.png",
    title: "문제 해결 중심의 풀스택 경험과 협업",
    description:
      "AWS 인프라 구축과 운영부터 백엔드 · 프론트엔드 개발, 3D 그래픽까지 다양한 도구를 활용해 문제에 유연하게 대응해왔습니다. 이를 바탕으로 다른 직군과 원활한 커뮤니케이션이 가능합니다.",
  },
];
